import { Injectable } from "@angular/core";
import { ServiceManager } from './service.manager';
import { SessionFactory } from '../caches/session.factory';
import { LocalStorageService } from './localstorage.service';
import { DatabaseWrappersFactory } from '../databases/database.wrappers.factory';
import { RepositoryManager } from '../../modules/repository/repository.manager';
import { Observable } from 'rxjs';
import { DIMsgObj } from '../models/dimsgobj';

@Injectable({
    providedIn: 'root'
})
export class StudioManager {
    sessionFactory: SessionFactory;
    constructor(private serviceManager: ServiceManager,
        private repositoryManager: RepositoryManager,
        private localStorageService: LocalStorageService) {
        this.sessionFactory = SessionFactory.getInstance();
    }

    getFldrs(): Observable<DIMsgObj> {
        return new Observable(observer => {
            if (this.sessionFactory.fldrs.length != 0 && this.sessionFactory.adminChangeFlg == 'N') {
                observer.next(new DIMsgObj());
                return;
            }

            this.serviceManager.getFldrs(this.sessionFactory.usr, 0, -1, '*', false)
                .subscribe(diMsgObj => {
                    if (diMsgObj.error_Cd != "0") {
                        observer.next(diMsgObj);
                        return;
                    }

                    if (this.sessionFactory.adminChangeFlg == 'Y') {
                        this.repositoryManager.packUserPrivileges()
                            .subscribe(diMsgObj => {
                            })
                    }

                    this.sessionFactory.updateFldrs(diMsgObj.retMsgObject.fldrs);
                    observer.next(diMsgObj);
                });
        })
    }

    /**
     * getDatabases() will get databases from local storager, if it is not present then it will get from server.
     * Note: observable is not working in Resolver, so Promise is used.
     */
    getDatabases(): any {
        return new Promise(resolve => {
            let databaseWrappersFactory: DatabaseWrappersFactory = DatabaseWrappersFactory.getInstance();
            if (!this.repositoryManager.repository.fldrObjectWrapper) {
                this.repositoryManager.createFldrObjectWrapper(this.sessionFactory.fldr);
            }

            let mappedFldrObjectWrapper = this.repositoryManager.repository.fldrObjectWrappersMap.get(this.repositoryManager.repository.fldrObjectWrapper.fldrObject.fldr.fldr_Id);
            if(!mappedFldrObjectWrapper) {
                this.repositoryManager.repository.fldrObjectWrappersMap.set(this.repositoryManager.repository.fldrObjectWrapper.fldrObject.fldr.fldr_Id, this.repositoryManager.repository.fldrObjectWrapper);
            }


            let fldr_Id: number = this.localStorageService.getObject('fldr_Id');
            if (fldr_Id == undefined ||
                fldr_Id != this.sessionFactory.fldr_Id) {
                this.localStorageService.clear();
                this.localStorageService.setObject('fldr_Id', this.sessionFactory.fldr_Id);
            }

            // else {
            //     let databases: Array<Database> = this.localStorageService.getObject('dataTypes');
            //     if (databases) {
            //         databaseWrappersFactory.setDatabases(databases);

            //         resolve(databases);
            //         return;
            //     }
            // }

            this.serviceManager.datatypesxml(this.sessionFactory.fldr_Id)
                .subscribe(diMsgObj => {
                    databaseWrappersFactory.setDatabases(diMsgObj.retMsgObject.database);
                    // this.localStorageService.setObject('dataTypes', diMsgObj.retMsgObject.database);

                    resolve(diMsgObj.retMsgObject.database);
                });
        });
    }

}